/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, SelectField, SelectOption, breakpoints } from '@coursera/cds-core';

import type { DropdownSelectProps } from 'bundles/onboarding-2022/types/GenericSelectProps';

import _t from 'i18n!nls/onboarding-2022';

const styles = {
  dropdownGroup: css`
    justify-content: center;
    align-items: center;
  `,
  dropdown: css`
    margin: var(--cds-spacing-300) 0 0 0;
    width: 568px;
    padding: 0 var(--cds-spacing-100);
    ${breakpoints.between('xs', 'sm')} {
      width: 468px;
    }
    ${breakpoints.down('xs')} {
      width: 350px;
    }
    ${breakpoints.down(375)} {
      max-width: 216px;
    }
  `,
};
const DropdownSelect: React.FC<DropdownSelectProps> = ({ question, options, value, questionId, onChange }) => {
  const handleChange = (event: { target: { value: any } }) => {
    onChange({ [questionId]: event.target.value });
  };

  // Hide component if options is an empty array or if the prompt is an empty string
  if (!options?.length) return null;
  if (!question) return null;
  return (
    <Grid css={styles.dropdownGroup}>
      <Grid key="dropdown-select" container css={styles.dropdown}>
        <SelectField
          data-testid="experience-level-select"
          id="experience-level-select"
          fullWidth={true}
          label={question}
          placeholder="Select an option"
          onChange={handleChange}
          value={value}
        >
          {options.map((option) => (
            <SelectOption key={`experience-level-${option.id}`} value={option.id}>
              {_t(option.text)}
            </SelectOption>
          ))}
        </SelectField>
      </Grid>
    </Grid>
  );
};

export default DropdownSelect;
